module.exports = __webpack_public_path__ + "static/media/logo_vietinbank.0a896e5a.svg";